<template>
	<Listbox as="div" v-model="selected">
		<div class="relative">
			<ListboxButton
				class="relative w-full cursor-default px-4 py-3 pl-3 pr-10 text-left text-gray-900 rounded-md bg-white shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6"
			>
				<span class="block min-w-[150px]">
					{{ $token(selected, true) }}
				</span>
				<span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
					<ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
				</span>
			</ListboxButton>
			<ListboxOptions
				class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white px-2 py-3 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
			>
				<ListboxOption
					as="template"
					v-for="currency in props.currencies"
					:key="currency"
					:value="currency"
					v-slot="{ active, selected }"
				>
					<li
						:class="[
							active ? 'bg-sky-600 text-white' : 'text-gray-900',
							'relative cursor-default select-none py-2 pl-3 pr-9 rounded',
						]"
					>
						<span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
							{{ $token(currency, true) }}
						</span>
						<span
							v-if="selected"
							:class="[
								active ? 'text-white' : 'text-sky-600',
								'absolute inset-y-0 right-0 flex items-center pr-4',
							]"
						>
							<CheckIcon class="h-5 w-5" aria-hidden="true" />
						</span>
					</li>
				</ListboxOption>
			</ListboxOptions>
		</div>
	</Listbox>
</template>
<script lang="ts" setup>
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/vue/20/solid'
import { computed } from 'vue'

const props = defineProps<{
	modelValue: string
	currencies: string[]
}>()

const emit = defineEmits<{
	(e: 'update:modelValue', value: string): void
}>()

const selected = computed({
	get: () => props.modelValue,
	set: (val: string) => emit('update:modelValue', val),
})
</script>
